import React from 'react';
import {FormattedMessage, IntlShape} from 'react-intl';
import config from '../../common/config';

let latestUrl = false;

export default class AgentLink extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            url: latestUrl || config.AGENT_URL
        };
    }

    componentDidMount() {
        if (!latestUrl) {
            fetch((config.GLOBAL_API_URL || config.apiHost) + '/public/agent-link', {
                headers: {}
            }).then((response) => {
                return response.json();
            }).then((parserResponse) => {
                if (parserResponse.status === "success") {
                    this.setState({
                        url: parserResponse.file
                    });
                    latestUrl = parserResponse.file;
                }
                else {
                    // reset the URL to the default one
                    latestUrl = false;

                    this.setState({
                        url: config.AGENT_URL
                    });
                }
            }).catch(() => {
                // reset the URL to the default one
                latestUrl = false;

                this.setState({
                    url: config.AGENT_URL
                });
            });
        }
    }

    render() {
        return (
            <a href={this.state.url} target="_new">
                <FormattedMessage defaultMessage="{productName} Agent" id="channelDef.requiresAgentName" values={{productName: config.PRODUCT_NAME}} />
            </a>
        );
    }
}
